function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_979",
  "data-name": "Group 979",
  transform: "translate(-791.725 -330.725)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_32",
  "data-name": "Ellipse 32",
  transform: "translate(791.725 330.725)",
  fill: "#fff",
  stroke: "#292929",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 7,
  r: 7,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 7,
  r: 6.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  id: "Icon_open-question-mark",
  "data-name": "Icon open-question-mark",
  d: "M2.68,0A2.8,2.8,0,0,0,.64.716,2.368,2.368,0,0,0,0,2.105l1.085.141A1.315,1.315,0,0,1,1.422,1.5,1.611,1.611,0,0,1,2.68,1.085,1.915,1.915,0,0,1,4,1.454a.907.907,0,0,1,.3.716c0,.9-.369,1.15-.912,1.628A3.093,3.093,0,0,0,2.138,6.24v.271H3.223V6.24A1.805,1.805,0,0,1,4.1,4.612,3.112,3.112,0,0,0,5.393,2.17,2.085,2.085,0,0,0,4.753.64,3,3,0,0,0,2.68,0ZM2.138,7.6V8.681H3.223V7.6Z",
  transform: "translate(796.099 333.365)",
  fill: "#292929"
}));

function SvgQuestionTooltip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionTooltip);
export default __webpack_public_path__ + "static/media/questionTooltip.ccfe984ea604762aac86ca795c963037.svg";
export { ForwardRef as ReactComponent };